<div class="page-footer">
  <div class="page-footer-inner container-fluid">
      VATM &copy;&nbsp; 2024
  </div>
  <div class="scroll-to-top">
      <i class="icon-arrow-up"></i>
  </div>
</div>
